import * as React from 'react'
import { Fragment, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next/hooks';
import { Link } from 'react-router-dom'

import { 
  KURASTORAGE_URL, 
  KURAIMAGEPHOTO_URL, 
} from '../../App'

import { useStore } from '../../hook-store/store'
import { marks } from '../../images/marks'
import './FilesUploadAction.css';

const FileUploadKuraInfo = (props) => {
  const { } = props

  const [t] = useTranslation('translation')

  const [store, dispatch] = useStore()

  let fileUploadKuraInfoBody = (
    <div className='fileUploadKuraInfo'>
      <div className='filesUploadActionSection'>
        {t('fileUploadAction09', 'Files can be uploaded after login for storing files')}
        {' '}to{' '}
        <a 
          href={`${KURASTORAGE_URL}/about`} 
          target="_blank" rel="noreferrer noopener"
        >
          Kura Storage 
        </a>
        {' '}or{' '} 
        <a 
          href={`${KURAIMAGEPHOTO_URL}/about`} 
          target="_blank" rel="noreferrer noopener"
        >
          Kura Image Photo 
        </a>.
        <div>
          {t('fileUploadAction10', 'Same account with this page can be used to login at these sites.')}
        </div>
      </div>

      <div className='filesUploadActionSection'>
        Kura Storage{' '}
        {t('fileUploadAction11', 'provides simple storage place for your files.')} 
        {' '}
        {t('fileUploadAction12', 'It has various tools for text and audio files.')}
      </div>

      <div className='filesUploadActionSection'>
        Kura Image Photo{' '}
        {t('fileUploadAction13', 'provides simple image file storage space.')}
        {' '}
        {t('fileUploadAction14', 'It has various image editing and generation tools as well.')}
        </div>
    </div>
  )

  return <Fragment>{fileUploadKuraInfoBody}</Fragment>
}

export default FileUploadKuraInfo;
